import classes from './Filtersection.module.scss';
import { Button } from 'primereact/button';
import { useFilterSection } from './useFilterSection.logic';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { FilterSectionProps } from 'Interfaces/FDPInterfaces/constrainedForecastBulkEdit';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import AsyncSelect from 'react-select/async';

const FilterSection: React.FC<FilterSectionProps> = ({
  filterpayload,
  isDataLoading: _isDataLoading,
  areChangesToBeSaved,
  handleApplyFilters,
  showAlert,
  setShowAlert,
}) => {
  const {
    RampingOptions,
    StratCodeOptions,
    SellingCategoryOptions,
    isAllMoleculesLoading,
    filteredMolecules,
    isAllConceptLoading,
    filteredConcept,
    setFilterValues,
    handleFilter,
    handlerFunctions,
    getfilterOption,
    filter,
    handleRestFilter,
  } = useFilterSection({
    filterpayload,
    handleApplyFilters,
  });

  return (
    <div className={classes.container}>
      <div className={classes.inputSection}>
        <div className={classes.labelSection}>
          <div>
            <label
              htmlFor="ramping"
              className={classes.inputLabel}
              style={{ paddingRight: '6rem' }}
            >
              Ramping:
            </label>
          </div>
          <div>
            <label
              htmlFor="molecule"
              className={classes.inputLabel}
              style={{ paddingRight: '5.9rem' }}
            >
              Molecule:
            </label>
          </div>
          <div>
            <label
              htmlFor="sellingCategory"
              className={classes.inputLabel}
              style={{ paddingRight: '3rem' }}
            >
              Selling category:
            </label>
          </div>
        </div>
        <div className={classes.inpSection}>
          <div>
            <Dropdown
              placeholder="Yes/No..."
              className={classes.dropDownBox}
              value={filter.Ramping}
              options={RampingOptions}
              optionLabel="label"
              optionValue="value"
              onChange={e => setFilterValues('Ramping', e.target.value)}
            />
          </div>
          <div>
            {/* molecule auto complete */}
            <AutoComplete
              onSelect={e => setFilterValues('MoleculeAndDosageForm', e.value)}
              autoHighlight={true}
              delay={200}
              loadingIcon={null}
              disabled={isAllMoleculesLoading}
              placeholder="Search a Molecule...."
              style={{ flexGrow: 1 }}
              className={classes.inputBox}
              value={filter.MoleculeAndDosageForm}
              suggestions={filteredMolecules}
              dropdownIcon={null}
              completeMethod={handlerFunctions.handleFilterMolecules}
              onChange={e => setFilterValues('MoleculeAndDosageForm', e.value)}
            />
          </div>
          <div>
            <Dropdown
              placeholder="Select a Selling category..."
              className={classes.dropDownBox}
              value={filter.SellingCategory}
              options={SellingCategoryOptions}
              optionLabel="label"
              optionValue="value"
              onChange={e => setFilterValues('SellingCategory', e.target.value)}
            />
          </div>
        </div>
        <div className={classes.labelSection}>
          <div>
            <label
              htmlFor="concept"
              className={classes.inputLabel}
              style={{ paddingRight: '5.9rem' }}
            >
              Concept:
            </label>
          </div>
          <div>
            <label
              htmlFor="stratCode"
              className={classes.inputLabel}
              style={{ paddingRight: '2.4rem' }}
            >
              Strategy Code:
            </label>
          </div>
          <div>
            <label
              htmlFor="ndc"
              className={classes.inputLabel}
              style={{ paddingRight: '7.5rem', marginTop: '0.5rem' }}
            >
              NDC:
            </label>
          </div>
        </div>
        <div className={classes.inpSection}>
          <div>
            {/* concept auto complete */}
            <AutoComplete
              onSelect={e => setFilterValues('Concept', e.value)}
              autoHighlight={true}
              delay={100}
              loadingIcon={null}
              disabled={isAllConceptLoading}
              placeholder="Search a concept...."
              style={{ flexGrow: 1, width: '100%', height: '2rem' }}
              className={classes.inputBox}
              value={filter.Concept}
              suggestions={filteredConcept}
              dropdownIcon={null}
              completeMethod={handlerFunctions.handleFilterConcepts}
              onChange={e => setFilterValues('Concept', e.value)}
            />
          </div>
          <div>
            <Dropdown
              placeholder="Select Strategy Code..."
              className={classes.dropDownBox}
              value={filter.StrategyCode}
              options={StratCodeOptions}
              optionLabel="label"
              optionValue="value"
              onChange={e => setFilterValues('StrategyCode', e.target.value)}
            />
          </div>
          <div>
            <AsyncSelect
              loadOptions={getfilterOption.fetchNDCSuggestions}
              onChange={option => {
                setFilterValues('NDC11', option?.value || '');
              }}
              defaultOptions
              placeholder="Search NDC11..."
              value={filter.NDC11 ? { label: filter.NDC11, value: filter.NDC11 } : null}
              styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 20 }),
              }}
            />
          </div>
        </div>
      </div>
      <div className={classes.btnComponent}>
        {/* Filter button section */}
        <div className={classes.btnContainer}>
          <Button
            className={classes.btn}
            style={{
              backgroundColor: 'rgb(247 243 254)',
              color: '#4d2e6d',
              border: '1px solid #4b5563',
            }}
            onClick={handleRestFilter}
          >
            Clear Filter
          </Button>
          <Button
            className={classes.btn}
            onClick={() => {
              if (areChangesToBeSaved) {
                setShowAlert(true);
              } else {
                handleFilter();
              }
            }}
            disabled={JSON.stringify(filter) === JSON.stringify(filterpayload)}
          >
            Apply
          </Button>
        </div>
      </div>
      <ConfirmationModal
        visibility={showAlert}
        modalHeading="Confirmation"
        modalContent="Changes are not saved, Are you sure you want to apply filter ?"
        loading={false}
        confirmLabel="Confirm"
        handleCancel={() => setShowAlert(false)}
        handleConfirm={() => {
          handleFilter();
          setShowAlert(false);
        }}
      />
    </div>
  );
};

export default FilterSection;
